import { isNotDefined, getMACalculator, getSourcePathAccessor } from "../utils";
import { MADeviation as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { windowSize, sourcePath, maType, mode } = options;

    const source = getSourcePathAccessor(sourcePath);

    // Get MA calculator using centralized utility
    const maCalculator = getMACalculator(maType);

    // Calculate MA values
    const maValues = maCalculator().options({ windowSize, sourcePath })(data);

    // Calculate deviation
    const deviations = data.map((d, i) => {
      const value = source(d);
      const ma = maValues[i];

      if (isNotDefined(value) || isNotDefined(ma)) {
        return undefined;
      }

      let deviation;
      if (mode === "Percent") {
        // Percent mode: 100 * (Close / MA - 1)
        deviation = 100 * (value / ma - 1);
      } else {
        // Points mode: Close - MA
        deviation = value - ma;
      }

      return deviation;
    });

    // Add direction flag for coloring bars (increasing vs decreasing)
    const result = deviations.map((value, i) => {
      if (isNotDefined(value)) return undefined;

      const prevValue = i > 0 ? deviations[i - 1] : undefined;
      let direction = "up";

      if (!isNotDefined(prevValue)) {
        direction = value >= prevValue ? "up" : "down";
      }

      return {
        value,
        direction,
      };
    });

    return result;
  }

  calculator.undefinedLength = function () {
    return options.windowSize - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
